import { createContext, useState, useEffect } from "react";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
    // Inizializza auth dallo sessionStorage (per persistenza temporanea) o localStorage (per persistenza permanente)
    const [auth, setAuth] = useState(() => {
        try {
            const persistedAuth = localStorage.getItem("persistedAuth");
            const sessionAuth = sessionStorage.getItem("sessionAuth");
            
            // console.log("🔄 AuthProvider init:", { 
            //     persistedAuth: !!persistedAuth, 
            //     sessionAuth: !!sessionAuth 
            // });
            
            if (persistedAuth) {
                const parsed = JSON.parse(persistedAuth);
                // console.log("✅ AuthProvider: Loaded from localStorage:", { 
                //     email: parsed.email, 
                //     hasToken: !!parsed.accessToken,
                //     userType: parsed.userType 
                // });
                return parsed;
            } else if (sessionAuth) {
                const parsed = JSON.parse(sessionAuth);
                // console.log("✅ AuthProvider: Loaded from sessionStorage:", { 
                //     email: parsed.email, 
                //     hasToken: !!parsed.accessToken,
                //     userType: parsed.userType 
                // });
                return parsed;
            }
            // console.log("❌ AuthProvider: No auth found in storage");
            return {};
        } catch (error) {
            console.error("❌ AuthProvider: Error loading auth from storage:", error);
            return {};
        }
    });
    
    const [persist, setPersist] = useState(JSON.parse(localStorage.getItem("persist")) || false);

    // Effetto per gestire la persistenza dell'auth
    useEffect(() => {
        if (auth?.accessToken) {
            if (persist) {
                // Se persist è true, salva in localStorage
                localStorage.setItem("persistedAuth", JSON.stringify(auth));
                sessionStorage.removeItem("sessionAuth");
            } else {
                // Se persist è false, salva solo in sessionStorage (per la sessione corrente)
                sessionStorage.setItem("sessionAuth", JSON.stringify(auth));
                localStorage.removeItem("persistedAuth");
            }
        } else {
            // Se non c'è token, rimuovi da entrambi
            localStorage.removeItem("persistedAuth");
            sessionStorage.removeItem("sessionAuth");
        }
        
        // console.log("Auth state changed:", auth);
    }, [auth, persist]);

    useEffect(() => {
        // console.log("Persist state changed:", persist);
        localStorage.setItem("persist", persist);
        
        // Se persist cambia, aggiorna la persistenza dell'auth
        if (auth?.accessToken) {
            if (persist) {
                const sessionAuth = sessionStorage.getItem("sessionAuth");
                if (sessionAuth) {
                    localStorage.setItem("persistedAuth", sessionAuth);
                    sessionStorage.removeItem("sessionAuth");
                }
            } else {
                const persistedAuth = localStorage.getItem("persistedAuth");
                if (persistedAuth) {
                    sessionStorage.setItem("sessionAuth", persistedAuth);
                    localStorage.removeItem("persistedAuth");
                }
            }
        }
    }, [persist, auth?.accessToken]);

    return (
        <AuthContext.Provider value={{ auth, setAuth, persist, setPersist }}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthContext;